module.exports = __webpack_public_path__ + "static/media/chronopost.e5cf6e24.svg";